import React, { useEffect, useMemo, useState } from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import HeroImage from "../../assets/images/HomePage.jpg";
import Button from "../components/Button";
import { useNavigate } from "react-router-dom";
import "../../css/LandingPage.css";
import { ReactComponent as FaviconIcon } from "../../assets/icons/favicon.svg";
import ReferAFriendPdf from "../../assets/resources/Refer a Friend.pdf";

const FALLBACK_REVIEWS = [
  // {
  //   authorName: "Andrew Lavnder",
  //   relativeTime: "4 months ago",
  //   text: "Great experience dealing with Marc Hoper from Just Mortgages. Highly recommendable for any mortgage support.",
  //   rating: 5,
  // },
  // {
  //   authorName: "Charlie Ambrose",
  //   relativeTime: "6 months ago",
  //   text: "Marc was amazing part of our journey when moving into our first home. Without his expertise, prompt responses and guidance...",
  //   rating: 5,
  // },
  // {
  //   authorName: "harry fawcett",
  //   relativeTime: "6 months ago",
  //   text: "I worked with Ava Rose mortgage advisor - Marc in regards of mortgages during the process of...",
  //   rating: 5,
  // },
];

const toStars = (rating = 0) =>
  "★".repeat(Math.max(0, Math.min(5, Math.round(rating))));

function LandingPage() {
  const navigate = useNavigate();
  const [reviewsData, setReviewsData] = useState(null);
  const [isLoadingReviews, setIsLoadingReviews] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchGoogleReviews = async () => {
      try {
        const response = await fetch("/api/google-reviews");
        if (!response.ok) {
          throw new Error("Unable to fetch Google reviews");
        }

        const data = await response.json();
        if (isMounted) {
          setReviewsData(data);
        }
      } catch (error) {
        if (isMounted) {
          setReviewsData(null);
        }
      } finally {
        if (isMounted) {
          setIsLoadingReviews(false);
        }
      }
    };

    fetchGoogleReviews();
    const intervalId = setInterval(fetchGoogleReviews, 120000);

    return () => {
      isMounted = false;
      clearInterval(intervalId);
    };
  }, []);

  const visibleReviews = useMemo(() => {
    const liveReviews = Array.isArray(reviewsData?.reviews)
      ? reviewsData.reviews
      : [];
    if (!liveReviews.length) {
      return FALLBACK_REVIEWS;
    }

    return liveReviews;
  }, [reviewsData]);

  const mapsLink =
    reviewsData?.googleMapsUri || "https://g.page/r/CbiUOlm6CTU_EAI/review";

  const totalRatingCount =
    reviewsData?.userRatingCount ?? FALLBACK_REVIEWS.length;
  const businessName = reviewsData?.placeName || "Ava Rose Mortgages Ltd";
  const businessRating = reviewsData?.rating ?? 5;

  return (
    <>
      <Hero
        title={"Ava Rose Mortgages"}
        subtitle={
          "Trusted Mortgage & Protection Advice for Life’s Important Moments"
        }
        backgroundImage={HeroImage}
        titleAlign="center"
        subtitleAlign="center"
      />
      <About />
      <Services />
      <div className="text-button-container">
        <p>
          At Ava Rose Mortgages, we are here to help you each step of the way to
          ensure your mortgage and protection journey is as smooth as possible.
        </p>
        <div className="footer-links">

        <Button
          text="Start your journey with us"
          onClick={() => navigate("/contact")}
        />
        <Button
          text="Refer a friend"
          onClick={() => window.open(ReferAFriendPdf, "_blank")}
        />
        </div>
      </div>

      <section className="reviews-strip" aria-label="Customer reviews">
        <div className="reviews-inner">
          <article className="review-card review-card-prompt">
            <div className="review-avatar"           
            >
              <FaviconIcon />
            </div>
            <div className="review-card-content">
              <h4 style={{ color: "var(--white)", textAlign: "center" }}>{businessName}</h4>
              {/* <p className="review-stars">{toStars(businessRating)}</p>
              <p>{totalRatingCount} Google reviews</p> */}
              <a
                href={mapsLink}
                target="_blank"
                rel="noreferrer"
                className="review-write-btn"
              >
                Write a review
              </a>
              {isLoadingReviews && (
                <p className="review-loading-text">Loading latest reviews...</p>
              )}
            </div>
          </article>

          {visibleReviews.map((review, index) => (
            <article
              key={`${review.authorName}-${index}`}
              className="review-card"
            >
              <div className="review-card-header">
                <div>
                  <h4>{review.authorName}</h4>
                  <p>{review.relativeTime || "Recently"}</p>
                </div>
                <span className="review-google-mark" aria-hidden="true">
                  G
                </span>
              </div>
              <p className="review-stars">{toStars(review.rating)}</p>
              <p>{review.text || "No review text available."}</p>
              <a
                href={review.authorUri || mapsLink}
                target="_blank"
                rel="noreferrer"
                className="review-read-more"
              >
                Read more
              </a>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}

export default LandingPage;
